import { useQuery } from '@tanstack/react-query';
import type AgentApiAiJobSearchRunsItem from '@/types/serializers/AgentApiAiJobSearchRunsItem';

/**
 * ペルソナの最新検索ランを取得するクエリ（決定3: ダイアログ再オープン時の結果復元用）
 *
 * 該当ランが存在しない場合、APIは `null` を返すため戻り値も null になりうる。
 */
export default function useFetchLatestAiJobSearchRun(personaId: number | null) {
  return useQuery({
    queryKey: ['aiJobSearchLatestRun', personaId],
    enabled: personaId !== null,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<AgentApiAiJobSearchRunsItem | null> => {
      const response = await fetch(
        `/agent/api/ai_job_search_runs?job_search_persona_id=${personaId}`,
        {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        throw new Error('最新検索ランの取得に失敗しました');
      }

      const data: AgentApiAiJobSearchRunsItem | null = await response.json();
      return data;
    },
  });
}
